import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { messages as m } from '../../../constants';
import * as D from '../../../deps';
import { getPodcastProgramDetailsById } from '../../../utils';

const integrationData = {
  contentSection: D.Constants.ContentSections.BackstageContentSections.THUMBED_EPISODES,
};
const ThumbedEpisodesWithLogger = D.withVisibilityLogger(integrationData, {
  staticHeight: D.RowItemHeights.SMALL,
})(D.ContentSection);

export class BackstagePodcastProgramThumbedEpisodes extends React.Component {
  static propTypes = {
    programId: PropTypes.string.isRequired,
    thumbedUpEpisodeCount: PropTypes.number,
    thumbedDownEpisodeCount: PropTypes.number,
    thumbsUpSeeAllUrl: PropTypes.string,
    thumbsDownSeeAllUrl: PropTypes.string,
    isMobileDevice: PropTypes.bool,
  };

  static defaultProps = {
    thumbedUpEpisodeCount: 0,
    thumbedDownEpisodeCount: 0,
  };

  renderThumbsRowItem({ isPositive }) {
    const {
      thumbedUpEpisodeCount,
      thumbedDownEpisodeCount,
      thumbsUpSeeAllUrl,
      thumbsDownSeeAllUrl,
    } = this.props;
    const thumbedRowItemMainText = isPositive ? m.thumbedUpEpisodes : m.thumbedDownEpisodes;
    const episodeCount = isPositive ? thumbedUpEpisodeCount : thumbedDownEpisodeCount;
    const seeAllLink = isPositive ? thumbsUpSeeAllUrl : thumbsDownSeeAllUrl;

    if (episodeCount > 0) {
      return (
        <D.RowItem
          mainText={<FormattedMessage {...thumbedRowItemMainText} />}
          secondText={
            <FormattedMessage
              {...D.Constants.Podcasts.messages.episodeCount}
              values={{ count: episodeCount }}
            />
          }
          rowUrl={seeAllLink}
          rightColChild={<FormattedMessage {...m.seeAll} />}
          isRowSmall={true}
          hideLeftCol={true}
          hasBorderTopBottom={true}
        />
      );
    }
    return null;
  }

  render() {
    const { thumbedUpEpisodeCount, thumbedDownEpisodeCount, isMobileDevice } = this.props;
    if ((thumbedUpEpisodeCount === 0 && thumbedDownEpisodeCount === 0) || isMobileDevice) {
      return null;
    }
    return (
      <D.Utils.Context.AppContextIntegrationData data={integrationData}>
        <ThumbedEpisodesWithLogger title={<FormattedMessage {...m.thumbs} />}>
          {this.renderThumbsRowItem({ isPositive: true })}
          {this.renderThumbsRowItem({ isPositive: false })}
        </ThumbedEpisodesWithLogger>
      </D.Utils.Context.AppContextIntegrationData>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const { programId } = ownProps;
  const annotation = D.getAnnotationsById(state, programId);
  const userProgramDetails = getPodcastProgramDetailsById(state, programId);
  const shareUrl = D.Utils.Core.getFromMap(annotation, 'shareableUrlPath');

  return {
    thumbedUpEpisodeCount: userProgramDetails.get('numThumbsUp'),
    thumbedDownEpisodeCount: userProgramDetails.get('numThumbsDown'),
    thumbsUpSeeAllUrl:
      shareUrl && D.Utils.Route.getBackstagePodcastProgramThumbedUpEpisodesPath(shareUrl),
    thumbsDownSeeAllUrl:
      shareUrl && D.Utils.Route.getBackstagePodcastProgramThumbedDownEpisodesPath(shareUrl),
    isMobileDevice: D.isMobileDevice(state),
  };
}

export default connect(mapStateToProps)(BackstagePodcastProgramThumbedEpisodes);
